<template>
 <div>
  <multiselect
    v-model="$store.state.valueGuild"
    :options="options"
    @input="onChange"
    placeholder="Selecciona Gremio"
    label="text"
    track-by="text"
    :show-labels="false"
  ></multiselect>
</div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import axios from "axios";
  import { mapMutations } from "vuex";
import config from '../../../helpers/config';

  export default {
    mounted() {
      this.getGuilds()
    },
    data () {
      return {
        valuex: [],
        value: [],
        options: []
      }
    },
    methods: {
      ...mapMutations([
        'filterExperiences'
      ]),
      onChange(event){
          //guildId
          //localStorage.setItem("gui_id", event.value)
          //console.log(event)
        this.value = event && event.value ? event.value: false
        this.filterExperiences({
          isObject: false,
          isArray: true,
          filter: 'guildIds',
          id: this.value
        })  
      },
      getGuilds(){
        axios.get(`${config.urlApi}/guilds`, {})
          .then(response => {
              response.data.forEach(element => {
                this.options.push({
                  value: element.id,
                  text: element.type
                })
            });
        })
        .catch(function (error) {
         ////console.log(error)
        })
      },
    },
    components: {
      Multiselect
    }
  }
</script>
